import { Modifier } from '@dnd-kit/core'

export const restrictToSpecificContainer = (containerId: string): Modifier => {
  return args => {
    const { transform, draggingNodeRect } = args

    if (!draggingNodeRect) {
      return transform
    }

    const container = document.getElementById(containerId)
    if (!container) {
      return transform
    }

    const containerRect = container.getBoundingClientRect()

    return {
      ...transform,
      x: Math.min(
        Math.max(transform.x, containerRect.left - draggingNodeRect.left),
        containerRect.right - draggingNodeRect.right
      ),
      y: Math.min(
        Math.max(transform.y, containerRect.top - draggingNodeRect.top),
        containerRect.bottom - draggingNodeRect.bottom
      )
    }
  }
}
